import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, from, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpResponse } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class APIService {

    constructor(private http: HttpClient) { }

    get(endpoint: string, token?: string, options?: { skipLoading?: boolean }): Observable<HttpResponse<any>> {
        const url = `${environment.apiUrl}${endpoint}`;
        console.log("URL: ", url);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            ...(options?.skipLoading ? { 'X-Skip-Loading': 'true' } : {})
        });

        return this.http.get<any>(url, {
            headers,
            observe: 'response'
        });
    }


    post(endpoint: string, data: any, token?: string): Observable<HttpResponse<any>> {
        const url = `${environment.apiUrl}${endpoint}`;
        console.log("URL: ", url)
        console.log("Body: ", data)
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        });
        console.log("Headers: ", headers)

        return this.http.post<any>(url, data, {
            headers,
            observe: 'response'  // 👈 This is the key
        });
    }

    postFormData1(endpoint: string, formData: FormData, token?: string): Observable<HttpResponse<any>> {
        const url = `${environment.apiUrl}${endpoint}`;
        console.log("URL: ", url);

        let headers = new HttpHeaders();
        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }

        // return this.http.post<any>(url, formData, {
        //   headers,
        //   observe: 'response'  // Get full HttpResponse including status
        // });

        return this.http.post(url, formData, { headers, observe: 'response' });
    }


    put(endpoint: string, data: any, token?: string): Observable<HttpResponse<any>> {
        const url = `${environment.apiUrl}${endpoint}`;
        console.log("URL: ", url)
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        });

        return this.http.put<any>(url, data, {
            headers,
            observe: 'response'  // <-- Important!
        });
    }

    patch(endpoint: string, data: any, token?: string): Observable<HttpResponse<any>> {
        const url = `${environment.apiUrl}${endpoint}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        });

        return this.http.patch<any>(url, data, {
            headers,
            observe: 'response'
        });
    }

    postFormData(endpoint: string, data: any, token: string) {
        const url = `${environment.apiUrl}${endpoint}`;
        const formData = new FormData();

        this.appendToFormData(formData, data);

        const headers = new HttpHeaders({
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        });

        return this.http.post(url, formData, { headers, observe: 'response' });
    }

    private appendToFormData(formData: FormData, data: any): void {
        for (const key in data) {
            const value = data[key];
            if (value === undefined || value === null) continue;
            if (value instanceof File) {
                formData.append(key, value, value.name);
            } else if (Array.isArray(value)) {
                value.forEach((item: any) => {
                    if (item instanceof File) {
                        formData.append(key, item, item.name);
                    } else if (item !== undefined && item !== null) {
                        formData.append(key, item);
                    }
                });
            } else {
                formData.append(key, value);
            }
        }
    }

    putFormData(endpoint: string, data: any, token?: string): Observable<HttpResponse<any>> {
        const url = `${environment.apiUrl}${endpoint}`;
        const formData = new FormData();

        this.appendToFormData(formData, data);

        const headers = new HttpHeaders({
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        });
        console.log("Headers: ", headers);

        return this.http.put(url, formData, {
            headers,
            observe: 'response'
        });
    }


    delete(endpoint: string, token?: string): Observable<any> {
        const url = `${environment.apiUrl}${endpoint}`;
        console.log("URL: ", url)
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        });

        return this.http.delete(url, { headers });
    }

}
